import { useState, useEffect } from 'react'
// react router
import { useParams, useNavigate } from 'react-router'
// redux
import { useSelector } from 'react-redux'
// axios
import enhancedAxios from '../../../utils/axiosUtils/enhancedAxios'
// formik
import { useFormik } from 'formik'
// schema
import { editRenewRequestSchema } from '../../../schemes/manageVendors/editRenewRequestSchema'
// components
import {
    PageTitle,
    MainButton,
    ErrorMessage,
    RingsLoader,
    DeleteButton,
} from '../../../components'
// mui
import { Stack, Autocomplete, TextField, Box, Button } from '@mui/material'
// alerts
import {
    errorAlert,
    successAlert,
    askForConfirmationAlert,
} from '../../../utils/alerts'

const subRequestStatus = [
    {
        title: 'قيد الانتظار',
        value: 'pending',
    },
    {
        title: 'مكتملة',
        value: 'completed',
    },
]
const monthsOptions = [
    {
        title: 'شهر',
        value: '1',
    },
    {
        title: 'شهرين',
        value: '2',
    },
    {
        title: '3 شهور',
        value: '3',
    },
    {
        title: '4 شهور',
        value: '4',
    },
    {
        title: '5 شهور',
        value: '5',
    },
    {
        title: '6 شهور',
        value: '6',
    },
    {
        title: '7 شهور',
        value: '7',
    },
    {
        title: '8 شهور',
        value: '8',
    },
    {
        title: '9 شهور',
        value: '9',
    },
    {
        title: '10 شهور',
        value: '10',
    },
    {
        title: '11 شهر',
        value: '11',
    },
    {
        title: '12 شهر',
        value: '12',
    },
]

const VendorEditRequest = () => {
    const { id } = useParams()
    const [paymentMethods, setPaymentMethods] = useState([])
    const [monthCost, setMonthCost] = useState(0)
    const [isLoading, setIsLoading] = useState(true)
    const userToken = useSelector((state) => state.userToken)
    const navigate = useNavigate()
    //  --------------------------------- handle auto change ---------------------------------
    const handleAutoChange = (e, newValue, belongTo) => {
        if (belongTo === 'months') {
            setValues((prev) => ({
                ...prev,
                cost: `${(
                    parseFloat(monthCost) * parseInt(newValue.value)
                ).toFixed(2)}`,
                months: newValue.value,
            }))
        }
        values[belongTo] = newValue.value
    }
    // --------------------------------- delete request ------------------------------------------------------------------
    const deleteProcess = () => {
        enhancedAxios(null, userToken)
            .delete(`/vendor/subscription-requests/${id}`)
            .then((response) => {
                successAlert('تم حذف الطلب')
                navigate('/vendor-subscription-requests')
            })
            .catch((error) => {
                errorAlert(error)
            })
    }
    // --------------------------------- submit ---------------------------------------------------------------------
    const onSubmit = (values) => {
        const formData = new FormData()
        for (let item in values) {
            formData.append(item, values[item])
        }
        enhancedAxios('multipart/form-data', userToken)
            .put(`/vendor/subscription-requests/${id}`, formData)
            .then((response) => {
                successAlert('تم تعديل الطلب')
                setSubmitting(false)
            })
            .catch((error) => {
                errorAlert(error)
            })
    }
    // --------------------------------- formik configration ----------------------------------------------------------
    const {
        values,
        setValues,
        handleChange,
        handleBlur,
        handleSubmit,
        errors,
        touched,
        isSubmitting,
        setSubmitting,
        resetForm,
    } = useFormik({
        initialValues: {
            months: '',
            cost: '',
            status: '',
            payment_method_id: '',
            note: '',
            vendor_id: '',
        },
        validationSchema: editRenewRequestSchema,
        onSubmit, //function we write above
    })
    const deleteRequest = () => {
        askForConfirmationAlert(
            'هل انت متاكد انك تريد حذف الطلب',
            deleteProcess
        )
    }

    // get payment methods from api
    useEffect(() => {
        enhancedAxios(null, null)
            .get(
                `/payment-methods?sorts=-created_at&page=1&paginate=1000%filters=is_disabled:eq:false`
            )
            .then((response) => {
                setPaymentMethods(response.data.data)
            })
            .catch((error) => {
                errorAlert(error)
            })
        // get request data
        enhancedAxios(null, userToken)
            .get(`/vendor/subscription-requests/${id}`)
            .then((response) => {
                setValues((prevValues) => ({
                    ...prevValues,
                    months: response.data.months,
                    cost: response.data.cost,
                    status: response.data.status,
                    payment_method_id: response.data.payment_method.id,
                    note: response.data.note,
                    vendor_id: response.data.vendor.id,
                }))
                setIsLoading(false)
            })

        // get month cost value
        enhancedAxios(null, null)
            .get(`/settings?q=cost`)
            .then((response) => {
                setMonthCost(response.data.data[0].value)
            })
    }, [])
    // loading untill data returned from api
    if (isLoading) {
        return <RingsLoader />
    }
    return (
        <Stack spacing={4} alignItems="center">
            <PageTitle title=" طلب تجديد الاشتراك" />
            <Stack
                component="form"
                onSubmit={handleSubmit}
                width="100%"
                maxWidth="700px"
                alignItems="center"
                spacing={2}
            >
                {/* months  */}
                <Autocomplete
                    disablePortal
                    options={monthsOptions}
                    name="months"
                    getOptionLabel={(option) => option.title ?? null}
                    isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                    }
                    onChange={(e, newValue) =>
                        handleAutoChange(e, newValue, 'months')
                    }
                    defaultValue={monthsOptions.find(
                        (opt) => opt.value == values.months
                    )}
                    value={monthsOptions.find(
                        (opt) => opt.value == values.months
                    )}
                    filterSelectedOptions
                    sx={{
                        width: '100%',
                    }}
                    renderInput={(params) => {
                        return (
                            <TextField
                                {...params}
                                label="مدة الاشتراك بالشهر"
                            />
                        )
                    }}
                />
                {/* cost  */}
                <TextField
                    label="قيمة الطلب"
                    name="cost"
                    value={values.cost}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                        readOnly: true,
                    }}
                    sx={{
                        width: '100%',
                    }}
                />
                {/* payment method  */}
                <Autocomplete
                    disablePortal
                    options={paymentMethods}
                    name="payment_method_id"
                    getOptionLabel={(option) => option.name ?? ''}
                    isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                    }
                    onChange={(e, newValue) =>
                        setValues((prevValues) => ({
                            ...prevValues,
                            payment_method_id: newValue.id,
                        }))
                    }
                    defaultValue={paymentMethods.find(
                        (opt) => opt.id == values.payment_method_id
                    )}
                    value={paymentMethods.find(
                        (opt) => opt.id == values.payment_method_id
                    )}
                    filterSelectedOptions
                    sx={{
                        width: '100%',
                    }}
                    renderInput={(params) => {
                        return <TextField {...params} label="طريقة الدفع" />
                    }}
                />
                {/* note  */}
                <TextField
                    label="ملاحظات"
                    name="note"
                    value={values.note}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    sx={{
                        width: '100%',
                    }}
                />
                {/* submit and error section  */}
                <Box width="100%" sx={{ '& button': { width: '100%' } }}>
                    <MainButton
                        text="طلب تجديد الاشتراك"
                        disabled={isSubmitting}
                    />
                    {/* errors section  */}
                    {errors && (
                        <Stack spacing={1}>
                            {errors.months && touched.months && (
                                <ErrorMessage errorMsg={errors.months} />
                            )}
                            {errors.cost && touched.cost && (
                                <ErrorMessage errorMsg={errors.cost} />
                            )}
                            {errors.status && touched.status && (
                                <ErrorMessage errorMsg={errors.status} />
                            )}
                            {errors.payment_method_id &&
                                touched.payment_method_id && (
                                    <ErrorMessage
                                        errorMsg={errors.payment_method_id}
                                    />
                                )}
                        </Stack>
                    )}
                </Box>
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <Button
                        size="large"
                        color="error"
                        variant="outlined"
                        onClick={deleteRequest}
                    >
                        {' '}
                        حذف الطلب{' '}
                    </Button>
                </Box>
            </Stack>
        </Stack>
    )
}

export default VendorEditRequest
